
export const hollyBio = {
  _id: 'hollyBioId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  aboutMe: [
    `Small-town girl who moved to NY for the opulence`,
    `New Yorker into shoes, restaurants, and melodrama`,
    `The girl you locked eyes with at the cafe but never talked to`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `The richest man in the city`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sleeping in with my cat, parties, and Tiffany's`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Is it better to be beautiful or smart?`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Design`,
    `Restaurants`,
    `Coffee`,
    `Writing`
  ],
  vitalInfo: {
    firstName: `Holly`, 
    age: 25,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 67,
    heightCM: 170,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Omaha`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: ``,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Sometimes`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const frodoBio = {
  _id: 'frodoBioId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  aboutMe: [
    `Hobbit who has travelled broadly but whose heart was always in The Shire`,
    `Destroyed The Ring so that I can present you a different type of ring`,
    `Finally on dating apps because everyone thinks I'm dating my best friend Sam`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A way to destroy The Ring and return to more peaceful times`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Idle days on The Shire`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Elfs or trolls?`,
    }
  ],
  hobbies: [
    `Feasts`,
    `Lawn Games`,
    `Diplomacy`,
    `Trekking`,
    `Idling`
  ],
  vitalInfo: {
    firstName: `Frodo`, 
    age: 22,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 60,
    heightCM: 155,
    inOrCmPreference: 'in',
    currentCity: `The Shire`,
    hometown: `The Shire`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: ``,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const gatsbyBio = {
  _id: 'gatsbyBioId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  aboutMe: [
    `Oggsford educated war hero of pedigree, old sport`,
    ``,
    ``
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `The green light`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Side-stepping Prohibion and throwing grand galas with the procedes`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Did Daisy ever love Tom?`,
    }
  ],
  hobbies: [
    `Parties`,
    `Cars`,
    `Boats`,
    `Alcohol`,
    `Black Markets`
  ],
  vitalInfo: {
    firstName: `Jay`, 
    age: 34,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 72,
    heightCM: 182,
    inOrCmPreference: 'in',
    currentCity: `East Egg`,
    hometown: `Chicago`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Oxford`,
    profession: `Investor`,
    employer: `Import/Export`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const luigiBio = {
  _id: 'luigiBioId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  aboutMe: [
    `Prep school valedictorian, Ivy league graduate, and cold-blooded killer looking for love`,
    `Lover of boardgames, hikes in nature, and cereal killer biographies`,
    `A literal hopeless romantic — I would've gotten away with murder if I hadn't pulled my mask down to flirt with the front desk woman at my hostel; now I'm in jail facing the death penalty.`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A solution to back pain`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Vigilante justice`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Why is the American healthcare system so broken?`,
    }
  ],
  hobbies: [
    `Activism`,
    `Boardgames`,
    `Hiking`,
    `Travel`,
    `3D Printing`
  ],
  vitalInfo: {
    firstName: `Luigi`, 
    age: 26,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 69,
    heightCM: 177,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Baltimore`,
    languages: [`English`, `Spanish`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `University of Pennsylvania`,
    profession: `Software Engineer`,
    employer: `Healthcare Company`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}